import { render, staticRenderFns } from "./TextareaForm.vue?vue&type=template&id=97eab27e&"
import script from "./TextareaForm.vue?vue&type=script&lang=js&"
export * from "./TextareaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports